import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  typeToConfirmInstruction: {
    id: 'course-authoring.generic.type-to-confirm-instruction',
    defaultMessage: 'Type <strong>{X}</strong> to confirm',
  },
});

export default messages;
